/**
 * The running app version, baked into the bundle at build time from
 * package.json (vite `define` → `__APP_VERSION__`). This is the single source
 * of truth for the client version — used for the header badge, the
 * update-check comparison, and feedback ticket context.
 *
 * The former `EXPO_PUBLIC_APP_VERSION` env var was never injected at runtime
 * (the container entrypoint doesn't emit it), so it always fell back to
 * "0.0.0". Read from here instead.
 */
export const APP_VERSION: string = __APP_VERSION__;
